import React from 'react';
import Typography from '@mui/material/Typography';

function BlogRecentPosts() {
    return (
        <div>
            <Typography variant="body1">BlogRecentPosts</Typography>
        </div>
    );
}

export default BlogRecentPosts;